import React from 'react'

import { Form, Col } from '_zari/core'

const FechaDesdeFormGroup = ({ value, onChange }) => {
  return (
    <Form.Group>
      <Form.Label text='F. DESDE' md={4} />
      <Col md={8}>
        <Form.InputDate id='date-fechaEmision' value={value} onChange={onChange} />
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaDesdeFormGroup)
